import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios, { AxiosRequestHeaders } from 'axios';
import loaderimage from "../../../images/giphy.gif";
import ConfirmationModal from "../../shared/ConfirmationModal";
import NewconfirmationModal from "../../shared/NewconfirmationModal";
import AllFailureModal from "../../shared/AllFailureModal";


interface Companies {
  company_id: string;
  company_name: string;
  team_size: number;
  email: string;
  established_in: string;
  contact_number: string;
  primary_industry: string;
  company_website: string;
  comp_registration_number: string;
  about_company: string;
  country: string;
  state: string;
  city: string;
  address: string;
  zip_code: string;
  facebook: string;
  twitter: string;
  linkedin: string;
  whatsapp: string;
  instagram: string;
  pinterest: string;
  isactive: boolean; 
  resolvestatus: string; 
  message: string; 
  subject: string; 
}

const CompaniesView = () => {
  const { company_id, userid } = useParams<{ company_id: string; userid: string }>();
  const [companies, setCompanies] = useState<any | undefined>(undefined);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState<string | undefined>(undefined);
  const [user, setUser] = useState<any>();
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [actionType, setActionType] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
   
   
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");

    const headers: AxiosRequestHeaders = {
      'x-access-token': localStorage.getItem('jwttoken') || '',
    };

  const fetchCompaniesById = async (id: string) => {
    try {
      setLoader(true);
      const url = `${process.env.REACT_APP_API_URL}companyDetails/bycompanyid/${id}`;
      const response = await axios.get<any>(url); 
      setCompanies(response.data[0]);
    } catch (error) {
      console.error("Error fetching Companies:", error);
      setError('Failed to fetch company data');
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (company_id) {
      fetchCompaniesById(company_id);
    } else {
      setLoader(false);
    }
  }, [company_id]);

const fetchUserById = async (id: any) => {
  try {
    setLoader(true);
    const url = `${process.env.REACT_APP_API_URL}users/finduser?id=${id}`;
    const response = await axios.get(url,{ headers });
    setUser(response.data[0])
  } catch (error) {
    console.error("Error fetching Users:", error);
    setError('Failed to fetch user data');
  } finally {
    setLoader(false);
  }
};

useEffect(() => {
  if (userid) {
    fetchUserById(userid);
  } else {
    setLoader(false);
  }
}, [userid])

  const handleAction = async () => {
    console.log(selectedUserId)
    if (!selectedUserId) return;
    try {
      let url = "";
      if (actionType === "Activate") {
        url = `${process.env.REACT_APP_API_URL}users/activateuser/${selectedUserId}`;
        await axios.put(url,{}, { headers });
        setSuccessMessage("User activated successfully.");
      } else if (actionType === "Deactivate") {
        url = `${process.env.REACT_APP_API_URL}users/deactivateuser/${selectedUserId}`;
        await axios.put(url,{}, { headers });
        setSuccessMessage("User deactivated successfully.");
      }
      fetchUserById(selectedUserId);
      setShowSuccessModal(true);

    } catch (error: any) {
      setFailureMessage(`Failed to ${actionType} user. ${error.message || ""}`);
      setShowFailureModal(true);
    } finally {
      setShowModal(false);
      setSelectedUserId(null);
    }
  };

  const triggerActionModal = (action: string, userId: number) => {
    setSelectedUserId(userId);
    setActionType(action);
    if (action === "Activate") {
      setModalMessage("Are you sure you want to activate this user?");
    } else if (action === "Deactivate") {
      setModalMessage("Are you sure you want to deactivate this user?");
    }
    setShowModal(true);
  };

  if (loader) {
    return (
      <div className="text-center py-5">
        <img src={loaderimage} alt="Loading..." height="40" />
      </div>
    );
  }
  if (error) {
    return <div>{error}</div>;
  }
  if (!companies) {
    return <div>No Companies found</div>;
  }

  return (
    <>
    <div className="container my-5">
  <div className="card shadow rounded-4 border-0">
    <div className="card-body p-4">
      <div className="text-center mb-5">
        <h2 className="text-primary fw-bold">{companies.company_name}</h2>
        <p className="text-muted">{companies.about_company}</p>
      </div>

      <div className="row g-4">
        <div className="col-md-6">
          <h6 className="fw-semibold text-secondary">Company ID</h6>
          <p>{companies.company_id}</p>
        </div>
        <div className="col-md-6">
          <h6 className="fw-semibold text-secondary">Registration Number</h6>
          <p>{companies.comp_registration_number}</p>
        </div>
        <div className="col-md-6">
          <h6 className="fw-semibold text-secondary">Team Size</h6>
          <p>{companies.team_size}</p>
        </div>
        <div className="col-md-6">
          <h6 className="fw-semibold text-secondary">Email</h6>
          <p>{companies.email}</p>
        </div>
        <div className="col-md-6">
          <h6 className="fw-semibold text-secondary">Established In</h6>
          <p>{companies.established_in}</p>
        </div>
        <div className="col-md-6">
          <h6 className="fw-semibold text-secondary">Contact Number</h6>
          <p>{companies.contact_number}</p>
        </div>
        <div className="col-md-6">
          <h6 className="fw-semibold text-secondary">Primary Industry</h6>
          <p>{companies.primary_industry}</p>
        </div>
        <div className="col-md-6">
          <h6 className="fw-semibold text-secondary">Website</h6>
          <p>
            <a href={companies.company_website} target="_blank" rel="noopener noreferrer">
              Visit Website
            </a>
          </p>
        </div>
        <div className="col-md-12">
          <h6 className="fw-semibold text-secondary">Address</h6>
          <p>
            {companies.address}, {companies.city_name}, {companies.state_name}, {companies.country_name}, {companies.post_code}
          </p>
        </div>
        <div className="col-md-12">
          <h6 className="fw-semibold text-secondary">LinkedIn</h6>
          <p>
            <a href={companies.linkedin} target="_blank" rel="noopener noreferrer">
              Visit LinkedIn Page
            </a>
          </p>
        </div>
        <div className="col-md-12">
          <h6 className="fw-semibold text-secondary">Social Media</h6>
          <div className="d-flex flex-wrap gap-3">
            {companies.facebook && <a href={companies.facebook} target="_blank" rel="noopener noreferrer">Facebook</a>}
            {companies.twitter && <a href={companies.twitter} target="_blank" rel="noopener noreferrer">Twitter</a>}
            {companies.instagram && <a href={companies.instagram} target="_blank" rel="noopener noreferrer">Instagram</a>}
            {companies.whatsapp && <a href={companies.whatsapp} target="_blank" rel="noopener noreferrer">Whatsapp</a>}
            {companies.pinterest && <a href={companies.pinterest} target="_blank" rel="noopener noreferrer">Pinterest</a>}
          </div>
        </div>
      </div>

      <hr className="my-5" />

      <div className="text-center">
        <button
          className={`btn btn-lg me-3 ${user && user.isactive === 1 ? "btn-outline-danger" : "btn-outline-success"}`}
          onClick={() =>
            triggerActionModal(
              user && user.isactive === 1 ? "Deactivate" : "Activate",
              user && user.userid
            )
          }
        >
          {user && user.isactive === 1 ? "Deactivate" : "Activate"}
        </button>
        <Link to="/companieslist" className="btn btn-lg btn-secondary">
          Go Back
        </Link>
      </div>
    </div>
  </div>
</div>

    <ConfirmationModal
            show={showModal}
            onHide={() => setShowModal(false)}
            modalMessage={modalMessage}
            confirmation={handleAction}
            operationType={actionType}
          />
          <NewconfirmationModal
            show={showSuccessModal}
            onHide={() => setShowSuccessModal(false)}
            modalMessage={successMessage}
            operationType="OK"
            timeoutDuration={3000}
          />
          <AllFailureModal
            show={showFailureModal}
            onHide={() => setShowFailureModal(false)}
            modalMessage={failureMessage}
            operationType="OK"
            timeoutDuration={5000}
          />
          </>
  );
};

export default CompaniesView;